"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultTheme = function defaultTheme(theme) {
  var stateSuccess = {
    color: theme.color.monochrome1["default"],
    backgroundColor: theme.color.success["default"],
    iconAppearance: 'primary',
    inverseIcon: true,
    borderColor: 'transparent',
    hover: {
      color: theme.color.monochrome1["default"],
      backgroundColor: theme.color.success.hover,
      borderColor: 'transparent',
      iconAppearance: 'primary'
    },
    pressed: {
      color: theme.color.monochrome1["default"],
      backgroundColor: theme.color.success.pressed,
      borderColor: 'transparent'
    }
  };
  var state = {
    success: stateSuccess,
    selected: stateSuccess
  };
  return {
    appearance: {
      primary: {
        color: theme.color.monochrome1["default"],
        backgroundColor: theme.color.primary1["default"],
        iconAppearance: 'primary',
        inverseIcon: true,
        borderColor: theme.color.primary1["default"],
        pressed: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.primary1.pressed,
          borderColor: theme.color.primary1.pressed
        },
        hover: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.primary1.hover,
          borderColor: theme.color.primary1.hover,
          iconAppearance: 'secondary'
        },
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          backgroundColor: theme.inverseColor.primary1["default"],
          iconAppearance: 'primary',
          inverseIcon: true,
          borderColor: theme.inverseColor.primary1["default"],
          pressed: {
            color: theme.inverseColor.monochrome6["default"],
            backgroundColor: theme.inverseColor.primary1.pressed,
            borderColor: theme.inverseColor.primary1.pressed
          },
          hover: {
            color: theme.inverseColor.monochrome6["default"],
            backgroundColor: theme.inverseColor.primary1.hover,
            borderColor: theme.inverseColor.primary1.hover,
            iconAppearance: 'secondary'
          }
        }
      },
      secondary: {
        color: theme.color.monochrome1["default"],
        backgroundColor: theme.color.monochrome6["default"],
        iconAppearance: 'primary',
        inverseIcon: true,
        borderColor: theme.color.monochrome6["default"],
        pressed: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.monochrome6.pressed,
          borderColor: theme.color.monochrome6.pressed
        },
        hover: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.monochrome6.hover,
          borderColor: theme.color.monochrome6.hover,
          iconAppearance: 'secondary'
        },
        inverse: {
          color: theme.inverseColor.monochrome1["default"],
          backgroundColor: theme.inverseColor.monochrome6["default"],
          iconAppearance: 'primary',
          inverseIcon: false,
          borderColor: theme.inverseColor.monochrome6["default"],
          pressed: {
            color: theme.inverseColor.monochrome1["default"],
            backgroundColor: theme.inverseColor.monochrome6.pressed,
            borderColor: theme.inverseColor.monochrome6.pressed
          },
          hover: {
            color: theme.inverseColor.monochrome1["default"],
            backgroundColor: theme.inverseColor.monochrome6.hover,
            borderColor: theme.inverseColor.monochrome6.hover,
            iconAppearance: 'primary'
          }
        }
      },
      alt1: {
        color: theme.color.monochrome6["default"],
        backgroundColor: 'transparent',
        pressed: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.monochrome6.pressed,
          borderColor: 'transparent'
        },
        iconAppearance: 'primary',
        inverseIcon: false,
        borderColor: theme.color.monochrome6["default"],
        hover: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.monochrome6.hover,
          borderColor: 'transparent',
          iconAppearance: 'primary'
        },
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          backgroundColor: 'transparent',
          pressed: {
            color: theme.inverseColor.monochrome1["default"],
            backgroundColor: theme.inverseColor.monochrome6.pressed,
            borderColor: 'transparent'
          },
          iconAppearance: 'primary',
          inverseIcon: true,
          borderColor: theme.color.monochrome1["default"],
          hover: {
            color: theme.inverseColor.monochrome1["default"],
            backgroundColor: theme.inverseColor.monochrome6.hover,
            borderColor: 'transparent',
            iconAppearance: 'alt1'
          }
        }
      },
      alt2: {
        color: theme.color.monochrome6["default"],
        backgroundColor: 'transparent',
        pressed: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.primary1.pressed,
          borderColor: 'transparent'
        },
        iconAppearance: 'primary',
        inverseIcon: false,
        borderColor: theme.color.primary1["default"],
        hover: {
          color: theme.color.monochrome1["default"],
          backgroundColor: theme.color.primary1.hover,
          borderColor: 'transparent',
          iconAppearance: 'alt1'
        },
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          backgroundColor: 'transparent',
          pressed: {
            color: theme.inverseColor.monochrome6["default"],
            backgroundColor: theme.inverseColor.primary1.pressed,
            borderColor: 'transparent'
          },
          iconAppearance: 'primary',
          inverseIcon: true,
          borderColor: theme.inverseColor.primary1["default"],
          hover: {
            color: theme.inverseColor.monochrome6["default"],
            backgroundColor: theme.inverseColor.primary1.hover,
            borderColor: 'transparent',
            iconAppearance: 'alt1'
          }
        }
      }
    },
    state: _objectSpread({}, state),
    borderRadius: theme.border.radius[2],
    borderWidth: theme.border.width[2]
  };
};
var _default = defaultTheme;
exports["default"] = _default;